// src/services/storage/BrowserStorageService.ts
// Implémentation réelle utilisant localStorage du navigateur

import { StorageService } from './types';

export class BrowserStorageService implements StorageService {
	getItem(key: string): string | null {
		try {
			return localStorage.getItem(key);
		} catch {
			console.warn(`[Storage] Failed to get item: ${key}`);
			return null;
		}
	}

	setItem(key: string, value: string): void {
		try {
			localStorage.setItem(key, value);
		} catch (error) {
			console.warn(`[Storage] Failed to set item: ${key}`, error);
		}
	}

	removeItem(key: string): void {
		try {
			localStorage.removeItem(key);
		} catch {
			console.warn(`[Storage] Failed to remove item: ${key}`);
		}
	}

	clear(): void {
		try {
			localStorage.clear();
		} catch {
			console.warn('[Storage] Failed to clear storage');
		}
	}

	getJSON<T>(key: string): T | null {
		const item = this.getItem(key);
		if (!item) return null;

		try {
			return JSON.parse(item) as T;
		} catch {
			console.warn(`[Storage] Failed to parse JSON for key: ${key}`);
			return null;
		}
	}

	setJSON<T>(key: string, value: T): void {
		try {
			this.setItem(key, JSON.stringify(value));
		} catch {
			console.warn(`[Storage] Failed to stringify JSON for key: ${key}`);
		}
	}

	hasItem(key: string): boolean {
		return this.getItem(key) !== null;
	}
}

// Instance singleton pour usage direct (hors React)
export const browserStorage = new BrowserStorageService();
